import { render, staticRenderFns } from "./AllClinics.vue?vue&type=template&id=6450dde3"
import script from "./AllClinics.vue?vue&type=script&lang=js"
export * from "./AllClinics.vue?vue&type=script&lang=js"
import style0 from "./AllClinics.vue?vue&type=style&index=0&id=6450dde3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports